import { render } from "./ClassBox.vue?vue&type=template&id=6ce0bb62&scoped=true&ts=true"
import script from "./ClassBox.vue?vue&type=script&lang=ts"
export * from "./ClassBox.vue?vue&type=script&lang=ts"

import "./box.css?vue&type=style&index=0&id=6ce0bb62&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce0bb62"]])

export default __exports__